import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const destinations = [
  {
    name: "Germany",
    sub: "Public & Private Universities",
    img: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=600&q=80",
  },
  {
    name: "Finland",
    sub: "Tech & Innovation Hubs",
    img: "https://images.unsplash.com/photo-1559561153-1a3af6e33b55?w=600&q=80",
  },
  {
    name: "Netherlands",
    sub: "Research & Design Centers",
    img: "https://images.unsplash.com/photo-1512470876302-972faa2aa9a4?w=600&q=80",
  },
  {
    name: "France",
    sub: "Business & Fine Arts",
    img: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&q=80",
  },
];

const steps = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
      </svg>
    ),
    title: "Initial Consultation",
    desc: "We assess your academic profile, language proficiency, and career goals to identify the best European university fit for your future.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z" />
      </svg>
    ),
    title: "University Selection",
    desc: "A curated shortlist of universities across Europe matching your budget and preferences, including detailed course analysis.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
      </svg>
    ),
    title: "Application Support",
    desc: "Professional guidance on crafting powerful Motivation Letters, CVs, and managing the entire submission portal process.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
      </svg>
    ),
    title: "Visa Assistance",
    desc: "Navigating complex bureaucracy with expert document vetting and interview preparation for your student visa application.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
      </svg>
    ),
    title: "Pre-departure Briefing",
    desc: "Cultural orientation, travel insurance advice, and essential survival tips for living and studying in your chosen country.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
      </svg>
    ),
    title: "On-arrival Support",
    desc: "From finding student housing to local registration and opening bank accounts, we ensure your landing is smooth and stress-free.",
  },
];

export default function Service() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className="min-h-screen font-sans"
      style={{ background: "#f4f4f8", fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        .fade-up {
          opacity: 0;
          transform: translateY(28px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }
        .fade-up.visible {
          opacity: 1;
          transform: translateY(0);
        }
        .card-img {
          filter: grayscale(100%);
          transition: filter 0.4s ease, transform 0.4s ease;
        }
        .dest-card:hover .card-img {
          filter: grayscale(0%);
          transform: scale(1.04);
        }
        .step-card:hover {
          box-shadow: 0 8px 32px rgba(108,47,246,0.12);
          transform: translateY(-3px);
        }
        .step-card {
          transition: box-shadow 0.25s, transform 0.25s;
        }
        .btn-primary {
          background: #6c2ff6;
          color: #fff;
          border: none;
          transition: background 0.2s, transform 0.15s;
        }
        .btn-primary:hover {
          background: #5a21e0;
          transform: translateY(-1px);
        }
        .btn-outline {
          background: transparent;
          color: #1a1a2e;
          border: 2px solid #d0d0e0;
          transition: border-color 0.2s, color 0.2s;
        }
        .btn-outline:hover {
          border-color: #6c2ff6;
          color: #6c2ff6;
        }
        .cta-banner {
          background: linear-gradient(115deg, #6c2ff6 0%, #7c3aed 60%, #9261f7 100%);
        }
        .tag-pill {
          background: rgba(108,47,246,0.1);
          color: #6c2ff6;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }
        .stat-badge {
          background: white;
          border-radius: 16px;
          box-shadow: 0 4px 24px rgba(0,0,0,0.1);
        }
        .services-img-wrap {
          background: rgba(108,47,246,0.08);
          border-radius: 20px;
          overflow: hidden;
          position: relative;
        }
        .services-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          mix-blend-mode: multiply;
          opacity: 0.7;
        }
        .explore-link {
          color: #6c2ff6;
          font-weight: 700;
          display: flex;
          align-items: center;
          gap: 4px;
          transition: gap 0.2s;
          cursor: pointer;
        }
        .explore-link:hover { gap: 8px; }
      `}</style>

      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "48px 24px", display: "flex", flexDirection: "column", gap: 64 }}>

        {/* ── SECTION 1: Services & Study Programs ── */}
        <section
          className={`fade-up ${visible ? "visible" : ""}`}
          style={{ display: "flex", gap: 48, alignItems: "center", flexWrap: "wrap" }}
        >
          <div style={{ flex: "1 1 340px", minWidth: 280 }}>
            <span className="tag-pill" style={{ display: "inline-block", padding: "5px 14px", borderRadius: 999, marginBottom: 18 }}>
              Expert Guidance
            </span>
            <h2 style={{ fontSize: "clamp(28px, 4vw, 42px)", fontWeight: 800, color: "#1a1a2e", lineHeight: 1.15, marginBottom: 8 }}>
              Our Services &{" "}
              <span style={{ color: "#6c2ff6" }}>Study Programs</span>
            </h2>
            <p style={{ color: "#5a5a72", fontSize: 15, lineHeight: 1.7, marginBottom: 28, maxWidth: 420 }}>
              Comprehensive support for your journey to top European universities. From initial discovery to settling into your new home, we are with you every step.
            </p>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <button onClick={() => navigate("/programs")} className="btn-primary" style={{ padding: "13px 26px", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                View All Programs
              </button>
              <button onClick={() => navigate("/eligibility")} className="btn-outline" style={{ padding: "13px 26px", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                Free Assessment
              </button>
            </div>
          </div>

          <div style={{ flex: "1 1 340px", minWidth: 280, position: "relative" }}>
            <div className="services-img-wrap" style={{ height: 300 }}>
              <img
                src="https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&q=80"
                alt="Students studying"
                className="services-img"
              />
              <div style={{ position: "absolute", inset: 0, background: "rgba(108,47,246,0.15)" }} />
            </div>
            <div
              className="stat-badge"
              style={{
                position: "absolute",
                bottom: -16,
                left: 24,
                padding: "14px 20px",
                display: "flex",
                alignItems: "center",
                gap: 14,
              }}
            >
              <div style={{ width: 42, height: 42, borderRadius: "50%", background: "#6c2ff6", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg viewBox="0 0 24 24" fill="white" width="20" height="20">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <div>
                <div style={{ fontWeight: 800, fontSize: 15, color: "#1a1a2e" }}>98% Success Rate</div>
                <div style={{ fontSize: 12, color: "#8888a0" }}>For university admissions in 2023</div>
              </div>
            </div>
          </div>
        </section>

        {/* ── SECTION 2: Study Abroad Process ── */}
        <section
          className={`fade-up ${visible ? "visible" : ""}`}
          style={{ animationDelay: "0.1s", transitionDelay: "0.1s" }}
        >
          <div style={{ textAlign: "center", marginBottom: 40 }}>
            <h2 style={{ fontSize: "clamp(22px, 3.5vw, 34px)", fontWeight: 800, color: "#1a1a2e", marginBottom: 12 }}>
              The Study Abroad Process
            </h2>
            <div style={{ width: 56, height: 4, background: "#6c2ff6", borderRadius: 2, margin: "0 auto" }} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 20 }}>
            {steps.map((s, i) => (
              <div
                key={i}
                className="step-card"
                style={{
                  background: "white",
                  borderRadius: 16,
                  padding: "28px 24px",
                  border: "1px solid rgba(108,47,246,0.08)",
                }}
              >
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: "rgba(108,47,246,0.1)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "#6c2ff6", marginBottom: 18
                }}>
                  {s.icon}
                </div>
                <h3 style={{ fontWeight: 700, fontSize: 16, color: "#1a1a2e", marginBottom: 10 }}>{s.title}</h3>
                <p style={{ color: "#5a5a72", fontSize: 14, lineHeight: 1.65 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── SECTION 3: Popular European Destinations ── */}
        <section
          className={`fade-up ${visible ? "visible" : ""}`}
          style={{ transitionDelay: "0.2s" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28, flexWrap: "wrap", gap: 16 }}>
            <div style={{ maxWidth: 480 }}>
              <h2 style={{ fontSize: "clamp(22px, 3.5vw, 34px)", fontWeight: 800, color: "#1a1a2e", marginBottom: 8 }}>
                Popular European Destinations
              </h2>
              <p style={{ color: "#5a5a72", fontSize: 14, lineHeight: 1.65 }}>
                Explore the most sought-after academic hubs across Europe. We have established partnerships with top-tier institutions in these regions.
              </p>
            </div>
            <span className="explore-link" style={{ whiteSpace: "nowrap", paddingTop: 8 }} onClick={() => navigate("/programs?tab=universities")}>
              Explore All
              <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z" />
              </svg>
            </span>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 16 }}>
            {destinations.map((d, i) => (
              <div
                key={i}
                className="dest-card"
                style={{ borderRadius: 18, overflow: "hidden", position: "relative", height: 320, cursor: "pointer" }}
              >
                <img src={d.img} alt={d.name} className="card-img" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                <div style={{
                  position: "absolute", inset: 0,
                  background: "linear-gradient(to top, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0) 55%)"
                }} />
                <div style={{ position: "absolute", bottom: 20, left: 20 }}>
                  <div style={{ color: "white", fontWeight: 800, fontSize: 18, marginBottom: 3 }}>{d.name}</div>
                  <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 13 }}>{d.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── SECTION 4: CTA Banner ── */}
        <section
          className={`fade-up ${visible ? "visible" : ""}`}
          style={{ transitionDelay: "0.3s" }}
        >
          <div
            className="cta-banner"
            style={{
              borderRadius: 20,
              padding: "36px 48px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 24,
            }}
          >
            <div>
              <h2 style={{ color: "white", fontWeight: 800, fontSize: "clamp(20px, 3vw, 28px)", marginBottom: 8 }}>
                Ready to start your journey?
              </h2>
              <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 14 }}>
                Join over 5,000 students who have successfully moved to Europe with UniEdu.fi.
              </p>
            </div>
            <button
              style={{
                background: "white",
                color: "#6c2ff6",
                border: "none",
                padding: "15px 30px",
                borderRadius: 12,
                fontWeight: 800,
                fontSize: 15,
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "transform 0.15s, box-shadow 0.15s",
                boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
              }}
              onClick={() => navigate("/contact")}
              onMouseEnter={e => { e.target.style.transform = "scale(1.03)"; e.target.style.boxShadow = "0 6px 24px rgba(0,0,0,0.18)"; }}
              onMouseLeave={e => { e.target.style.transform = "scale(1)"; e.target.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)"; }}
            >
              Book a Free Consultation
            </button>
          </div>
        </section>

      </div>
    </div>
  );
}


// import { useState } from "react";
// import finland from "../../assets/countryImage/Flag_of_Finland.png";
// import spain from "../../assets/countryImage/Bandera_de_España.svg";
// import cyprus from "../../assets/countryImage/Flag-Cyprus.webp";
// import malta from "../../assets/countryImage/Flag_of_Malta.png";
// import Netherlands from "../../assets/countryImage/Flag_of_the_Netherlands.png";
// import Italy from "../../assets/countryImage/Flag_of_Italy.svg.webp";
// import France from "../../assets/countryImage/Flag_of_France.svg.png";
// import Poland from "../../assets/countryImage/Flag_of_Poland.svg.png";
// import Latvia from "../../assets/countryImage/Flag_of_Latvia.svg.png";
// import Lithuania from "../../assets/countryImage/flag_of_Lithuania.png";
// import { AiFillClockCircle } from "react-icons/ai";
// import { FaCheckCircle, FaPhone } from "react-icons/fa";
// const ServiceCharge = () => {
//   const [activeCountry, setActiveCountry] = useState(0);

//   const countries = [
//     {
//       name: "Finland",
//       flag: finland,
//       process: [
//         "Choose university and program",
//         "Receive I-20 form from university",
//         "Pay SEVIS fee",
//         "Complete DS-160 form online",
//         "Schedule visa interview",
//         "Attend visa interview",
//         "Receive visa decision",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "4-6 weeks",
//       successRate: "100%",
//     },
//     {
//       name: "Spain",
//       flag: spain,
//       process: [
//         "Get admission letter",
//         "Prepare financial documents",
//         "Submit visa application",
//         "Biometric enrollment",
//         "Visa decision",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "6-8 weeks",
//       successRate: "95%",
//     },
//     {
//       name: "Cyprus",
//       flag: cyprus,
//       process: [
//         "Apply to institution",
//         "Receive conditional letter",
//         "Make tuition deposit",
//         "Submit visa documents",
//         "Visa approval",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "3-6 weeks",
//       successRate: "80%",
//     },
//     {
//       name: "Italy",
//       flag: Italy,
//       process: [
//         "Apply through University portal",
//         "Pre-enrollment at consulate",
//         "Submit visa documents",
//         "Wait for decision",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "4-8 weeks",
//       successRate: "95%",
//     },
//     {
//       name: "Netherlands",
//       flag: Netherlands,
//       process: [
//         "University application",
//         "Pay tuition deposit",
//         "Institution applies MVV visa",
//         "Collect MVV from embassy",
//         "Travel & register in municipality",
//       ],
//       openingCharge: 140,
//       visaCharge: 1420,
//       processingTime: "3-6 weeks",
//        successRate: "95%",
//     },
//     {
//       name: "France",
//       flag: France,
//       process: [
//         "Campus France registration",
//         "Academic interview",
//         "Visa application submission",
//         "Biometrics",
//         "Visa result",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "3-5 weeks",
//        successRate: "95%",
//     },
//     {
//       name: "Poland",
//       flag: Poland,
//       process: [
//         "Apply to University",
//         "Receive acceptance letter",
//         "Submit visa file",
//         "Biometrics",
//         "Decision",
//       ],
//       openingCharge: 140,
//       visaCharge: 1420,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "6-12 weeks",
//     successRate: "95%",
//     },
//     {
//       name: "Latvia",
//       flag: Latvia,
//       process: [
//         "University admission",
//         "Prepare financial documents",
//         "Visa application submission",
//         "Embassy interview",
//         "Decision",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "3-7 weeks",
//     successRate: "95%",
//     },
//     {
//       name: "Malta",
//       flag: malta,
//       process: [
//         "Apply to institution",
//         "Tuition fee payment",
//         "Prepare visa file",
//         "Submit at embassy",
//         "Visa approval",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "4-6 weeks",
//       successRate: "82%",
//     },
//     {
//       name: "Lithuania",
//       flag: Lithuania,
//       process: [
//         "Admission offer",
//         "Prepare financial & academic documents",
//         "Submit visa application",
//         "Biometrics",
//         "Decision",
//       ],
//       openingCharge: 140,
//       visaCharge: 710,
//       spouseService: 360,
//       childService: 360,
//       processingTime: "4-8 weeks",
//        successRate: "95%",
//     },
//   ];

//   const totalCharge = (country) => country.openingCharge + country.visaCharge;

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">
//             Global Education Consultancy
//           </h1>
//           <p className="text-lg text-gray-600 max-w-2xl mx-auto">
//             Your trusted partner for student visa services. We guide you through
//             the entire process with transparent pricing and expert support.
//           </p>
//         </div>

//         {/* Country Selection */}
//         <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-8">
//           {countries.map((country, index) => (
//             <button
//               key={index}
//               onClick={() => setActiveCountry(index)}
//               className={`p-4 rounded-lg border-2 transition-all duration-300 ${
//                 activeCountry === index
//                   ? "border-blue-500 bg-blue-50 shadow-lg transform scale-105"
//                   : "border-gray-200 bg-white hover:border-blue-300"
//               }`}
//             >
//               <div className="text-2xl mb-2">
//                 <img src={country.flag} alt="" />
//               </div>
//               <div className="font-semibold text-gray-800">{country.name}</div>
//             </button>
//           ))}
//         </div>

//         {/* Main Content */}
//         <div className="bg-white rounded-xl shadow-lg overflow-hidden">
//           <div className="grid md:grid-cols-2 gap-8 p-6">
//             {/* Left Side - Process */}
//             <div>
//               <div className="flex items-center mb-6">
//                 <div className="text-3xl mr-4 w-20">
//                   <img src={countries[activeCountry].flag} alt="" />
//                 </div>
//                 <div>
//                   <h2 className="text-2xl font-bold text-gray-800">
//                     {countries[activeCountry].name} Student Visa Process
//                   </h2>
//                   <div className="flex items-center space-x-4 mt-2 text-sm text-gray-600">
//                     <span className="flex items-center gap-1.5 "><AiFillClockCircle size={18}   className="text-blue-500" /> {countries[activeCountry].processingTime}</span>
//                     <span className="flex items-center gap-1.5 ">
//                        <FaCheckCircle size={18} className="text-green-500" /> {countries[activeCountry].successRate} success rate
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 {countries[activeCountry].process.map((step, index) => (
//                   <div key={index} className="flex items-start space-x-3">
//                     <div className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
//                       {index + 1}
//                     </div>
//                     <div className="bg-gray-50 p-3 rounded-lg flex-1">
//                       <p className="text-gray-700">{step}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* Right Side - Charges */}
//             <div className="bg-gray-50 rounded-lg p-6">
//               <h3 className="text-xl font-bold text-gray-800 mb-6 text-center">
//                 Service Charges
//               </h3>

//               <div className="space-y-4 mb-6">
//                 <div className="flex justify-between items-center p-4 bg-white rounded-lg border">
//                   <div>
//                     <h4 className="font-semibold text-gray-800">
//                       File Opening Charge
//                     </h4>
//                     <p className="text-sm text-gray-600">
//                       One-time documentation fee
//                     </p>
//                   </div>
//                   <div className="text-lg font-bold text-blue-600">
//                     €{countries[activeCountry].openingCharge}
//                   </div>
//                 </div>

//                 <div className="flex justify-between items-center p-4 bg-white rounded-lg border">
//                   <div>
//                     <h4 className="font-semibold text-gray-800">
//                       Visa Processing Charge
//                     </h4>
//                     <p className="text-sm text-gray-600">
//                       Payable after visa approval
//                     </p>
//                   </div>
//                   <div className="text-lg font-bold text-green-600">
//                     €{countries[activeCountry].visaCharge}
//                   </div>
//                 </div>
//                 <div className="flex justify-between items-center p-4 bg-white rounded-lg border">
//                   <div>
//                     <h4 className="font-semibold text-gray-800">
//                       Spouse Service Charge
//                     </h4>
//                     <p className="text-sm text-gray-600">
//                       Payable after visa approval
//                     </p>
//                   </div>
//                   <div className="text-lg font-bold text-green-600">
//                     €{countries[activeCountry].childService}
//                   </div>
//                 </div>
//                 <div className="flex justify-between items-center p-4 bg-white rounded-lg border">
//                   <div>
//                     <h4 className="font-semibold text-gray-800">
//                       Child Service Charge
//                     </h4>
//                     <p className="text-sm text-gray-600">
//                       Payable after visa approval
//                     </p>
//                   </div>
//                   <div className="text-lg font-bold text-green-600">
//                     €{countries[activeCountry].childService}
//                   </div>
//                 </div>
//               </div>

//               {/* Total */}
//               <div className="border-t pt-4">
//                 {/* <div className="flex justify-between items-center mb-4">
//                   <span className="text-lg font-bold text-gray-800">
//                     Total Charges for (File +Visa Processing ) 
//                   </span>
//                   <span className="text-2xl font-bold text-purple-600">
//                     € {totalCharge(countries[activeCountry])}
//                   </span>
//                 </div> */}
//                 <p className="text-sm text-gray-600 text-center mb-4">
//                   No hidden fees. No additional charges.
//                 </p>
//                 <p className="text-sm text-gray-600 text-center mb-4">
//                   No hidden fees. No additional charges.
//                 </p>

//                 {/* <button className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg font-semibold transition duration-300">
//                   Start Your Application
//                 </button> */}
//               </div>

//               {/* Additional Info */}
//               <div className="mt-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
//                 <h4 className="font-semibold text-yellow-800 mb-2">
//                   💰 Payment Information
//                 </h4>
//                 <ul className="text-sm text-yellow-700 space-y-1">
//                   <li>• File opening charge paid initially</li>
//                   <li>• Visa charge paid after document verification</li>
//                   {/* <li>• All amounts in USD</li> */}
//                   <li>• 100% refund if visa rejected</li>
//                   <li>
//                     • Bank transfer* to UniEdu’s official account (details
//                     available &nbsp; &nbsp; &nbsp; &nbsp; upon request)
//                   </li>
//                   <li>
//                     • *Cash payment* at our Bangladesh office with official
//                     receipt
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Summary Cards */}
//         <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-8">
//           {countries.map((country, index) => (
//             <div key={index} className="bg-white rounded-lg p-4 shadow border">
//               <div className="flex items-center  justify-between mb-2">
//                 <span className="text-xl">
//                   <img src={country.flag} alt="" />
//                 </span>
//               </div>
//               <div className="text-sm font-semibold text-gray-700">
//                 {country.name}
//               </div>
//               <div className="text-xs text-gray-500 mt-1">
//                 {country.processingTime}
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Footer Note */}
//         <div className="text-center mt-8 text-gray-600">
//           <p>
//             Need help choosing the right country? Contact our education experts
//             for free counseling!
//           </p>
//           <div className="mt-4 space-x-4 flex items-center justify-center">
//             <a
//               href="https://wa.me/358442762209"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <button className="bg-green-500 hover:bg-green-600 duration-300 text-white px-6 py-2 rounded-lg flex gap-2 ">
//                 <FaPhone /> Call on WhatsApp
//               </button>
//             </a>

//             <button className="bg-blue-600 hover:bg-blue-700 duration-300 text-white px-6 py-2 rounded-lg flex gap-2 ">
//               <FaPhone /> Call on 019XXXXXXXXX
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServiceCharge;
